import { useQuery } from '@apollo/client/react';

import { SalesTaxDocument } from '@graphql/platform';
import { AvalaraTaxItemCode } from '@graphql/platform';

import { useSharedCheckoutContext } from '@root/components/checkout/context';

export const useProtectionTaxRate = () => {
  const {
    flowState: { values },
  } = useSharedCheckoutContext();
  const zip = values.zip;

  return (
    useQuery(SalesTaxDocument, {
      variables: {
        zipCode: zip!,
        avalaraItemCode: AvalaraTaxItemCode.Default,
      },
      skip: !zip,
    }).data?.salesTax.percent ?? 0
  );
};
